import { useAbTestFeatureVariant } from '@sprd/sprd-abtest-next/client';

/**
 * Client-side gate for the "free-shipping-banner" A/B test (DEV-230488):
 * show the mini-basket free-shipping banner only for the `visible` variant.
 * Control (`hidden`, also the fallback) keeps the previous experience.
 */
export const useIsFreeShippingBannerEnabled = () => {
  return useAbTestFeatureVariant("free-shipping-banner", "hidden") === "visible";
};